import { ProductSliderSources } from "@omni/types/components/product/enums/productSliderResource.enum";
import { productSlider } from "@omni/ui/brand/product/productSlider/productSlider.styles";
import { ReactNode } from "react";

import { useProductSliderContext } from "@/components/Product/ProductSlider/context/productSlider.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    const { source, allowNext, allowPrev } = useProductSliderContext();

    const { slider } = productSlider();

    const centered =
        source === ProductSliderSources.Recent && !allowNext && !allowPrev;

    return (
        <div
            className={slider({
                centered: centered,
                className: className
            })}
        >
            {children}
        </div>
    );
};
